
<template>
    <v-container fluid>
    <v-card elevation="0" flat tile>
        <v-card-text>
            <v-row justify="center">
                <v-col cols="12" md="12">
                    <v-row>
                        <v-col md="6">
                        <p class="text-h5">Settings</p>
                        </v-col>
                        <v-col md="6" align=right>
                            <v-btn
                            class="button-shadow mr-1"
                            color="secondary"
                            @click="isAddSetting = true"
                            >
                            Add
                            </v-btn>
                            <v-btn
                                class="button-shadow mr-1"
                                to="/company/list"
                                replace
                                color="primary"
                            >
                                Done
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-data-table
                sort-by="settingrank"
                :headers="header_items"
                :items="data_settings"
                :items-per-page="500"
                class="elevation-0"
            >
                <template v-slot:top>
                    <v-dialog v-model="isDeleteSetting" width="500">
                        <v-card>
                            <v-card-title> Delete this Setting? </v-card-title>
                            <v-card-text>
                            {{ delete_setting.settingcode }}
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    outlined
                                    @click="isDeleteSetting = false"
                                    >Cancel</v-btn
                                >
                                <v-btn
                                    color="secondary"
                                    class="button-shadow"
                                    @click="deleteCompanySetting(delete_setting)"
                                    >Delete
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </template>
                <template v-slot:item.settingrank="{ item }">
                    {{ item.settingrank }}
                </template> 
                <template v-slot:item.settingcode="{ item }">
                    {{ item.settingcode }}
                </template>                    
                <template v-slot:item.createdAt="{ item }">
                    {{
                        new Date(item.createdAt).toLocaleString("en-SG", { year: "numeric", month: "numeric", day: "numeric" })
                    }}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn
                        icon
                        color="primary"
                        @click="editCompanySettingDialog(item)"
                        >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        color="primary"
                        @click="deleteCompanySettingDialog(item)"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
    <div>
        <v-dialog
            v-model="isAddSetting"
            persistent
            width="1000px"
            max-width="1000px"
        >
            <v-card>
                <v-card-title>
                <span class="text-h5">Add Setting</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="1">
                                <v-text-field
                                v-model="add_setting.settingrank"
                                class="mb-4"
                                placeholder="Num"
                                type="number"
                                oninput="if(this.value < 0) this.value = 0;"
                                single-line
                                hint="Num"
                                dense
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-select
                                class="mb-4"
                                :items="['Company Settings', 'Tax Settings', 'Currency Settings', 'Document Settings']"
                                v-model="add_setting.settingtype"
                                placeholder="Type"
                                dense
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="add_setting.settingcode"
                                    label="Code"
                                    required
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="add_setting.settingvalue"
                                    label="Value"
                                    required
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-select
                                class="mb-4"
                                :items="['String', 'Number', 'Json']"
                                v-model="add_setting.valuetype"
                                placeholder="Type"
                                dense
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-textarea
                                    v-model="add_setting.settingdata"
                                    rows=10
                                    label="Data"
                                    required
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="isAddSetting=false; add_setting={}"
                >
                    Close
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="addCompanySetting"
                >
                    Save
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="isEditSetting"
            persistent
            width="1000px"
            max-width="1000px"
        >
            <v-card>
                <v-card-title>
                <span class="text-h5">Edit Setting</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="1">
                            <v-text-field
                            v-model="edit_setting.settingrank"
                            class="mb-4"
                            placeholder="Num"
                            type="number"
                            oninput="if(this.value < 0) this.value = 0;"
                            single-line
                            hint="Num"
                            dense
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-select
                                class="mb-4"
                                :items="['Company Settings', 'Tax Settings', 'Currency Settings', 'Document Settings']"
                                v-model="edit_setting.settingtype"
                                placeholder="Type"
                                dense
                            >
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="edit_setting.settingcode"
                                label="Code"
                                required
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="edit_setting.settingvalue"
                                label="Value"
                                required
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select
                                class="mb-4"
                                :items="['String', 'Number', 'Json']"
                                v-model="edit_setting.valuetype"
                                placeholder="Type"
                                dense
                                >
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="12">
                            <v-textarea
                                v-model="edit_setting.settingdata"
                                rows=10
                                label="Data"
                                required
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="isEditSetting=false; edit_setting={}"
                >
                    Close
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="editCompanySetting"
                >
                    Save
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    </v-container>
</template>

<script>
import {mapActions} from "vuex";
import { formatHtmlText } from '../../../util/tools';
export default {
    props: {
        data: {
            type: Array
        },
        id: String,
    },
    data () {
        return {
            header_items: [
                { text: "#", value: "settingrank", width: "10px" },
                { text: "Type", value: "settingtype" },
                { text: "Code", value: "settingcode" },
                { text: "Value", value: "settingvalue" },
                { text: "", value: "valuetype", width: "10%" },
                { text: "Actions", value: "actions", sortable: false , width: "10%"},
            ],
            data_settings: [],
            isAddSetting: false,
            isDeleteSetting: false,
            isEditSetting: false,
            add_setting: {},
            delete_setting: {},
            edit_setting: {},
            formatHtmlText: formatHtmlText,
        }
    },
    methods: {
        ...mapActions('Company', [ 'insertCompanySettingRequest', 'deleteCompanySettingRequest', 'updateCompanySettingRequest']),
        async addCompanySetting() {
            this.isAddSetting = false;
            this.add_setting.id = this.id;
            let result = await this.insertCompanySettingRequest(this.add_setting);
            if(result!=null) this.data_settings.splice(0,0,result);
            this.add_setting = {};
        },
        deleteCompanySettingDialog(item) {
            this.isDeleteSetting = true;
            this.delete_setting = { _id: item._id, settingcode: item.settingcode };
        },
        async deleteCompanySetting(item) {
            this.isDeleteSetting = false;
            let result = await this.deleteCompanySettingRequest(item);
            let index = this.data_settings.findIndex((i) => i._id == result._id);
            this.data_settings.splice(index, 1);
        },
        editCompanySettingDialog(item) {
            this.isEditSetting = true;
            this.edit_setting = Object.assign({},item);
        },
        async editCompanySetting() {
            this.isEditSetting = false;
            let result = await this.updateCompanySettingRequest(this.edit_setting);
            let index = this.data_settings.findIndex((i)=> i._id == result._id);
            this.data_settings.splice(index, 1, result);
        },
    },
    created(){
        this.data_settings = Object.assign([], this.data);
    }
}
</script>